<script setup lang="ts">
import type { IconOptions, VueClass } from '@/kasten-components/types';
import { cnMerge } from '@/utils/utils.js';

import { comboboxIconSlotVariants } from './combobox-variants';

export type KaComboboxIconSlotProps = {
  class?: VueClass;
  iconOptions?: IconOptions;
};

const props = withDefaults(defineProps<KaComboboxIconSlotProps>(), {
  class: '',
  iconOptions: undefined,
});

defineSlots<{
  default?(): any;
}>();
</script>
<template>
  <span :class="cnMerge(comboboxIconSlotVariants(), props.class)" aria-hidden="true">
    <slot>
      <component
        :is="props.iconOptions?.icon"
        v-if="props.iconOptions?.icon"
        :class="cnMerge('size-3.5', props.iconOptions?.classes)"
      />
    </slot>
  </span>
</template>
